module.exports = __webpack_public_path__ + "img/404-not-found.18d1735e.png";